import React from 'react'
import { gql, useQuery } from '@apollo/client'

export type Gewerbeamt = {
	id: string
	name: string
	department: string | null
	email: string | null
	street: string | null
	zipCode: string | null
	city: string | null
	sourceUrl: string | null
	note: string | null
}

const RESTAURANT_GEWERBEAMT_QUERY = gql`
	query RestaurantGewerbeamt($restaurantId: ID!) {
		restaurant(id: $restaurantId) {
			id
			gewerbeamt {
				id
				name
				department
				email
				street
				zipCode
				city
				sourceUrl
				note
			}
		}
	}
`

// Das Gewerbeamt zur Anschrift des Restaurants; null, wenn dazu keins hinterlegt ist.
export const useGewerbeamt = (
	restaurantId: string
): { gewerbeamt: Gewerbeamt | null | undefined; loading: boolean } => {
	const { data } = useQuery(RESTAURANT_GEWERBEAMT_QUERY, {
		variables: { restaurantId },
		fetchPolicy: 'network-only',
	})

	return React.useMemo(
		() => ({
			gewerbeamt: data?.restaurant?.gewerbeamt,
			loading: data?.restaurant === undefined,
		}),
		[data?.restaurant]
	)
}
